module.exports = __webpack_public_path__ + "static/media/website.1d6fa4d4.svg";